import React from "react";
import styled from "styled-components";
import MrktOp1 from "../images/Buildyourstrategic-01.svg";
import MrktOp2 from "../images/Scoutompanies.svg";
import MrktOp3 from "../images/ChoosetherightIdeapoke-01.svg";
import RegulatoryFFF from "../images/Regulatorypoliciescancome-01.svg";
import MapImageText from "../DesignTeam/MapImageText";
import MapsTextImage from "../DesignTeam/MapsTextImage";
import { RobotoFontWrapper } from "../IPWebsiteRedesign/RobotoFont";
import { ExploreResearchSolutions } from "../MarketAnalysis/ExploreResearchSolutions";
import { FinalBanner } from "../MarketAnalysis/FinalBanner";

const CookieWrap = styled.div`
  text-align: center;
  margin: 0 auto;
  margin-top: 0px;
`;

export default function NewCookies(props) {
  let contentArr = [
    "Be it a 3 year plan, 5 year or 10 year long term plan, New Business Development deserves different approaches.",
  ];
  let contentArr1 = [
    "Staying informed about new and emerging startups in the industry allows to gain a competitive edge.",
  ];
  let contentArr2 = [
    "Navigate compliance requirements, licensing, permits, safety standards, environmental regulations, and data protection laws in new geographies with power of information upfront.",
  ];
  let contentArr3 = [
    "Different New Business development horizons need different approaches and tools.",
    "Choose the right Ideapoke solutions for your needs",
  ];

  return (
    <div>
      <RobotoFontWrapper>
        <CookieWrap>
          <MapsTextImage
            Content={contentArr3}
            rightImg={MrktOp3}
          ></MapsTextImage>
          <MapImageText
            Title="Build your strategic action plans with key market projections"
            Content={contentArr}
            dImage={MrktOp1}
          ></MapImageText>
          <MapsTextImage
            Heading="Scout companies and startups in a particular area"
            Content={contentArr1}
            rightImg={MrktOp2}
          ></MapsTextImage>
          <MapImageText
            Title="Regulatory policies can come in the way of your company's plans"
            Content={contentArr2}
            dImage={RegulatoryFFF}
          ></MapImageText>
        </CookieWrap>
        <ExploreResearchSolutions Teams={true} title={props.title}></ExploreResearchSolutions>
        <FinalBanner />
      </RobotoFontWrapper>
    </div>
  );
}
